var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { QuiTooltip } from "../QuiTooltip/QuiTooltip.js";
import { WithIcon } from "../_primitives/WithIcon.js";
import { useQuiMenu } from "./QuiMenuContext.js";
export const QuiMenuItem = forwardRef((_a, ref) => {
    var { onClick, to, external, download, disabled, iconLeft, iconRight, tooltip, tooltipProps, tabIndex, className, children } = _a, otherProps = __rest(_a, ["onClick", "to", "external", "download", "disabled", "iconLeft", "iconRight", "tooltip", "tooltipProps", "tabIndex", "className", "children"]);
    const { close } = useQuiMenu();
    const menuItemText = (React.createElement(WithIcon, { iconLeft: iconLeft, iconRight: iconRight },
        React.createElement("span", { className: classNames("qui-menu-item-text") }, children)));
    const sharedProps = Object.assign({ className: classNames(className, "qui-menu-item"), role: "menuitem", tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0 }, otherProps);
    const menuItemElement = (() => {
        if (disabled) {
            return (React.createElement("span", Object.assign({ "aria-disabled": true, ref: ref }, sharedProps, { className: classNames(sharedProps.className, "qui-menu-item-disabled") }), menuItemText));
        }
        else if (!to) {
            return (React.createElement("button", Object.assign({ ref: ref, onClick: onClick }, sharedProps), menuItemText));
        }
        else if (download || external) {
            return (React.createElement("a", Object.assign({ download: download, target: external ? "_blank" : undefined, rel: external ? "noopener noreferrer" : undefined, href: to, ref: ref }, sharedProps), menuItemText));
        }
        else {
            return (React.createElement(Link, Object.assign({ onClick: close }, sharedProps, { ref: ref, to: to }), menuItemText));
        }
    })();
    if (tooltip) {
        // default to a horizontal tooltip placement to help prevent tooltip from covering up options
        const ttProps = tooltipProps !== null && tooltipProps !== void 0 ? tooltipProps : { placement: "left" };
        return (React.createElement(QuiTooltip, Object.assign({}, ttProps, { content: React.createElement("div", null, tooltip) }), menuItemElement));
    }
    return menuItemElement;
});
QuiMenuItem.displayName = "QuiMenuItem";
